import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const CAPTCHA_ACTION = new HttpContextToken<string | undefined>(() => undefined);

@Injectable()
export class CaptchaInterceptor implements HttpInterceptor {
  constructor(private readonly recaptcha: ReCaptchaV3Service) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const action = req.context.get(CAPTCHA_ACTION);

    if (!action) {
      return next.handle(req);
    }

    return this.recaptcha.execute(action).pipe(
      catchError((error) => {
        console.error('Error ejecutando reCAPTCHA:', error);
        return throwError(() => new Error('Captcha execution failed'));
      }),
      switchMap((token) =>
        next.handle(req.clone({ headers: req.headers.set('x-captcha-token', token) })),
      ),
    );
  }
}
